<template>
  <div class="hello">
    <NavbarVue />
    <Swiper/>
    <div
      :class="isActive ? 'fixed' : 'hidden'"
      class="bg-black/[0.9] top-0 left-0 bottom-0 w-[100%] h-[100%] z-999"
    >
      <div class="h-[100%] flex items-center justify-center">
        <div class="relative inline-block">
          <iframe
            src="https://www.youtube.com/embed/S_CGed6E610"
            width="700"
            height="500"
            frameborder="0"
          ></iframe>
          <a
            class="mdi mdi-close text-white absolute top-1 right-1 text-xl"
            @click="toggle"
          ></a>
        </div>
      </div>
    </div>
    <!-- Hero End -->
    <!-- Hero End -->
    <AboutVue />
    <featuresVue :isHome="true" />
    <cta />
    <!-- <Blogs /> -->
    <!-- <pricing /> -->

    <!-- <GetInTouch /> -->
    <Footer />
  </div>
</template>
  
<script>
import NavbarVue from "../components/Navbar.vue";
import AboutVue from "../components/AboutComponent.vue";
import featuresVue from "../components/FeaturesComponent.vue";
import cta from "../components/Cta.vue";
// import Blogs from "../components/BlogComponent.vue";
// import pricing from "../components/PricingComponent.vue";
// import GetInTouch from "@/components/GetInTouchComponent.vue";
import Footer from "@/components/Footer.vue";
import Swiper from "@/components/Swiper.vue";
export default {
  name: "IndexPage",
  data() {
    return {
      isActive: false,
    };
  },
  components: {
    NavbarVue,
    AboutVue,
    featuresVue,
    cta,
    Swiper,
    // pricing,
    // Blogs,
    // GetInTouch,
    Footer,
  },

  methods: {
    toggle() {
      if (!this.isActive) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
};
</script>
  
<style scoped lang="scss">
.right-img {
  border: 1px solid #ccc;
  padding: 10px;
  // border-radius: 20px;
  @media (max-width: 1023px) {
    display: none;
  }
  img {
    // border-radius: 20px;
    height: 100%;
  }

}
.index-svg{
    fill: #ffffff90;
  }
  .index-svg:hover{
    fill: #ffffff;
  }
</style>
  